type Language = 'en' | 'th';

export const translations = {
    en: {
        // Nav
        'nav.about': 'About',
        'nav.experience': 'Experience',
        'nav.projects': 'Projects',
        'nav.certifications': 'Certifications',
        'nav.events': 'Events',
        'nav.contact': 'Contact',
        'nav.menu': 'Navigation',
        'nav.menu.close': 'Tap outside to close',
        'nav.menu.label': 'Menu',

        // Hero
        'hero.greeting': 'Hello, I\'m',
        'hero.name': 'Charcrith',
        'hero.tagline': 'CS student at Bangkok University.',
        'hero.line': 'Full-stack — self-hosted, live in production.',
        'hero.slogan.lead': 'From idea',
        'hero.slogan.to': 'to',
        'hero.slogan.w1': 'production',
        'hero.slogan.w2': 'interface',
        'hero.slogan.w3': 'deploy',
        'hero.view_projects': 'View Projects',
        'hero.contact': 'Get in Touch →',

        // About
        'about.title1': 'About ',
        'about.title2': 'Me',
        'about.desc1': 'I\'m a Computer Science student at ',
        'about.desc1.bu': 'Bangkok University',
        'about.desc1.spec': ', with a focus on ',
        'about.desc1.ds': 'Data Science',
        'about.desc1.and': ' and ',
        'about.desc1.cyber': 'Cybersecurity.',
        'about.desc2': 'I\'m driven by a love for building things that are both secure and beautifully simple. Whether it\'s architecting a robust backend or polishing a pixel-perfect UI, I care deeply about every layer of the stack.',
        'about.edu.bu': 'Bangkok University',
        'about.edu.fac': 'School of Information Technology and Innovation',
        'about.edu.major': 'CS — Data Science & Cybersecurity',
        'about.edu.label': 'Education',
        'about.focus': 'CS · Data · Cyber',
        'about.skills1': 'Technical ',
        'about.skills2': 'Skills',
        'about.skills.langs': 'Languages',
        'about.skills.frontend': 'Frontend',
        'about.skills.backend': 'Backend',
        'about.skills.data': 'Data',
        'about.skills.platform': 'Platform',

        // Experience
        'exp.title1': 'Work ',
        'exp.title2': 'Experience',
        'exp.download': 'Download Resume',
        'exp.e1.role': 'Backend Developer',
        'exp.e1.company': 'Center of Specialty Innovation (CoSI)',
        'exp.e1.period': 'Current',
        'exp.e1.desc': 'Contributing to innovative solutions that integrate multimedia content with AI technologies. Working on backend architecture and API development.',

        // Projects
        'proj.title1': 'Featured ',
        'proj.title2': 'Projects',
        'proj.gallery': 'Projects',
        'proj.desc': 'Scroll through a curated selection of my recent work',
        'proj.open': 'Open project',
        'proj.click': 'Click to expand',
        'proj.tech': 'Tech Stack',
        'proj.code': 'View Code',
        'proj.demo': 'Live Demo',
        'proj.prev': 'Prev',
        'proj.next': 'Next',
        'proj.continue': 'Continue Scrolling',
        'proj.github1': 'GitHub ',
        'proj.github2': 'Activity',
        'proj.github.act': 'Contribution Activity',
        'proj.github.desc': 'A snapshot of my open-source contributions and coding consistency over the past year.',
        'proj.p1.title': 'E-learning Platform',
        'proj.p1.desc': 'An educational platform that integrates with OneDrive to store and stream learning materials, including images and videos. Built for efficient content management and delivery.',
        'proj.p2.title': 'Tourism Website',
        'proj.p2.desc': 'Implemented Google OAuth Authentication for enhanced security and simplified access. Developed a secure Forgot Password system using OTP to ensure quick and safe account recovery, preventing unauthorized access.',
        'proj.p3.title': 'Expense Tracker Web App',
        'proj.p3.desc': 'A comprehensive personal finance tool for tracking income and expenses. Features include interactive data visualization, transaction categorization, and budget management to help users maintain financial health.',
        'proj.p4.title': 'E-learning Platform Refactor',
        'proj.p4.desc': 'A production-ready healthcare e-learning platform for hospital personnel training. Built with multi-role access for students, teachers, and admins. Features course management, progress tracking, certificate generation, and OneDrive media integration.',
        'proj.p5.title': 'Tourism Website Refactor',
        'proj.p5.desc': 'A full-stack tourism platform connecting communities, local businesses, and tourists across Thailand. Features multi-role RBAC, interactive maps, AI-generated reviews, multilingual support (TH/EN/ZH/JA), and Cloudflare R2 file storage.',
        'proj.p6.title': 'Real-time Collaboration Platform',
        'proj.p6.desc': 'A full-stack real-time collaboration platform (like Discord) built with a Bun + Elysia backend and an Electron desktop app. Features workspace management, real-time messaging, LiveKit voice channels, dual-language support, and PostgreSQL.',

        // Certs
        'cert.title1': 'Certifications ',
        'cert.title2': '& Events',
        'cert.showcreds': 'View Credential',
        'cert.filter.certs': 'Certifications',
        'cert.filter.events': 'Events',
        'cert.swipehint': 'swipe cards · tap to open',
        'cert.field.issuer': 'Issuer',
        'cert.field.date': 'Date',
        'cert.field.location': 'Location',

        // Events
        'events.title1': 'Events & ',
        'events.title2': 'Activities',

        // Contact
        'contact.title1': 'Let\'s Build',
        'contact.title2': 'Something Great',
        'contact.desc': 'Open to internships, freelance collaborations, and full-time opportunities. Got an idea? Let\'s bring it to life.',
        'contact.reach': 'Reach out via',
        'contact.email.label': 'Send an Email',
        'contact.email.cta': 'Write to me →',
        'contact.github.label': 'Visit my GitHub',
        'contact.github.cta': 'Browse repos →',
        'contact.location': 'Bangkok, Thailand · Typically replies within 24 hours',
    },
    th: {
        // Nav
        'nav.about': 'เกี่ยวกับผม',
        'nav.experience': 'ประสบการณ์',
        'nav.projects': 'ผลงาน',
        'nav.certifications': 'ใบรับรอง',
        'nav.events': 'กิจกรรม',
        'nav.contact': 'ติดต่อ',
        'nav.menu': 'เมนูหลัก',
        'nav.menu.close': 'แตะด้านนอกเพื่อปิด',
        'nav.menu.label': 'เมนู',

        // Hero
        'hero.greeting': 'สวัสดีครับ ผม',
        'hero.name': 'ชาคริต',
        'hero.tagline': 'นักศึกษา CS มหาวิทยาลัยกรุงเทพ',
        'hero.line': 'Full-stack — self-hosted ขึ้น production จริง',
        'hero.slogan.lead': 'จากไอเดีย',
        'hero.slogan.to': 'สู่',
        'hero.slogan.w1': 'ระบบจริง',
        'hero.slogan.w2': 'อินเทอร์เฟซ',
        'hero.slogan.w3': 'การขึ้นระบบ',
        'hero.view_projects': 'ดูผลงาน',
        'hero.contact': 'ทักมาได้เลย →',

        // About
        'about.title1': 'เกี่ยวกับ',
        'about.title2': 'ผม',
        'about.desc1': 'ผมเรียน CS อยู่ที่ ',
        'about.desc1.bu': 'มหาวิทยาลัยกรุงเทพ',
        'about.desc1.spec': ' เน้นด้าน ',
        'about.desc1.ds': 'Data Science',
        'about.desc1.and': ' กับ ',
        'about.desc1.cyber': 'Cybersecurity',
        'about.desc2': 'ผมชอบสร้างของที่ทั้งปลอดภัยและใช้งานง่าย ไม่ว่าจะเป็น Backend ที่แข็งแกร่ง หรือ UI ที่ปรับแต่งมาดี ผมดูแลทุกส่วนของการพัฒนาอย่างละเอียด',
        'about.edu.bu': 'มหาวิทยาลัยกรุงเทพ',
        'about.edu.fac': 'คณะเทคโนโลยีสารสนเทศและนวัตกรรม',
        'about.edu.major': 'วิทยาการคอมพิวเตอร์ — Data Science & Cybersecurity',
        'about.edu.label': 'การศึกษา',
        'about.focus': 'CS · Data · Cyber',
        'about.skills1': 'ทักษะ',
        'about.skills2': 'เทคนิค',
        'about.skills.langs': 'ภาษา',
        'about.skills.frontend': 'หน้าเว็บ',
        'about.skills.backend': 'แบ็กเอนด์',
        'about.skills.data': 'ข้อมูล',
        'about.skills.platform': 'แพลตฟอร์ม',

        // Experience
        'exp.title1': 'ประสบการณ์',
        'exp.title2': 'ทำงาน',
        'exp.download': 'โหลด Résumé',
        'exp.e1.role': 'นักพัฒนา Backend',
        'exp.e1.company': 'ศูนย์นวัตกรรมเฉพาะทาง (CoSI)',
        'exp.e1.period': 'ปัจจุบัน',
        'exp.e1.desc': 'ร่วมพัฒนาโซลูชันที่ผสานเนื้อหามัลติมีเดียกับเทคโนโลยี AI พร้อมออกแบบสถาปัตยกรรม Backend และพัฒนา API',

        // Projects
        'proj.title1': 'ผลงาน',
        'proj.title2': 'ของผม',
        'proj.gallery': 'ผลงาน',
        'proj.desc': 'เลื่อนดูผลงานที่ผมทำมาได้เลย',
        'proj.open': 'เปิดโปรเจกต์',
        'proj.click': 'คลิกเพื่อดูเพิ่ม',
        'proj.tech': 'Tech Stack',
        'proj.code': 'ดูโค้ด',
        'proj.demo': 'ลองใช้งาน',
        'proj.prev': 'ก่อนหน้า',
        'proj.next': 'ถัดไป',
        'proj.continue': 'เลื่อนต่อเลย',
        'proj.github1': 'กิจกรรม ',
        'proj.github2': 'GitHub',
        'proj.github.act': 'ความเคลื่อนไหวใน GitHub',
        'proj.github.desc': 'ดูว่าผมเขียนโค้ดสม่ำเสมอแค่ไหนในปีที่ผ่านมา',
        'proj.p1.title': 'แพลตฟอร์มเรียนออนไลน์',
        'proj.p1.desc': 'แพลตฟอร์มการศึกษาที่เชื่อมต่อกับ OneDrive เพื่อจัดเก็บและสตรีมเนื้อหาการเรียนรู้ ทั้งภาพและวิดีโอ สร้างขึ้นเพื่อการจัดการและส่งมอบเนื้อหาที่มีประสิทธิภาพ',
        'proj.p2.title': 'เว็บไซต์ท่องเที่ยว',
        'proj.p2.desc': 'นำ Google OAuth มาใช้เพื่อเพิ่มความปลอดภัยในการเข้าสู่ระบบ และพัฒนาระบบลืมรหัสผ่านโดยใช้ OTP เพื่อให้กู้คืนบัญชีได้อย่างรวดเร็วและปลอดภัย ป้องกันการเข้าถึงโดยไม่ได้รับอนุญาต',
        'proj.p3.title': 'แอปติดตามค่าใช้จ่าย',
        'proj.p3.desc': 'เครื่องมือจัดการการเงินส่วนตัวที่ครอบคลุม สำหรับติดตามรายรับและรายจ่าย มีฟีเจอร์แสดงผลข้อมูลแบบ interactive การแบ่งประเภทธุรกรรม และการจัดการงบประมาณ เพื่อช่วยให้ผู้ใช้มีสุขภาพทางการเงินที่ดี',
        'proj.p4.title': 'E-learning Platform Refactor',
        'proj.p4.desc': 'แพลตฟอร์มการเรียนออนไลน์ด้านสุขภาพสำหรับบุคลากรทางการแพทย์ รองรับหลายบทบาท ทั้งนักเรียน ผู้สอน และผู้ดูแลระบบ พร้อมระบบจัดการคอร์ส ติดตามความก้าวหน้า สร้างใบรับรอง และเชื่อมต่อ OneDrive สำหรับจัดเก็บสื่อการสอน',
        'proj.p5.title': 'Tourism Website Refactor',
        'proj.p5.desc': 'แพลตฟอร์มท่องเที่ยวแบบ Full-Stack ที่เชื่อมชุมชน ธุรกิจท้องถิ่น และนักท่องเที่ยวทั่วไทย รองรับหลายบทบาท มีแผนที่แบบ Interactive รีวิวจาก AI รองรับหลายภาษา (ไทย/อังกฤษ/จีน/ญี่ปุ่น) และจัดเก็บไฟล์ผ่าน Cloudflare R2',
        'proj.p6.title': 'แพลตฟอร์มทำงานร่วมกันแบบเรียลไทม์',
        'proj.p6.desc': 'แอปพลิเคชันทำงานร่วมกันแบบเรียลไทม์ (คล้าย Discord) ประกอบด้วย Backend API (Bun + Elysia) และ Desktop App (Electron) รองรับระบบ Workspace, แชทเรียลไทม์, คุยรเสียงผ่าน LiveKit, หลายภาษา, และฐานข้อมูล PostgreSQL',

        // Certs
        'cert.title1': 'ใบรับรอง ',
        'cert.title2': '& กิจกรรม',
        'cert.showcreds': 'ดูใบรับรอง',
        'cert.filter.certs': 'ใบรับรอง',
        'cert.filter.events': 'กิจกรรม',
        'cert.swipehint': 'ปัดการ์ด · แตะเพื่อเปิด',
        'cert.field.issuer': 'ผู้ออก',
        'cert.field.date': 'วันที่',
        'cert.field.location': 'สถานที่',

        // Events
        'events.title1': 'กิจกรรม',
        'events.title2': 'ที่เคยเข้าร่วม',

        // Contact
        'contact.title1': 'มาทำงาน',
        'contact.title2': 'ด้วยกันเลย',
        'contact.desc': 'รับทั้งอินเทิร์น ฟรีแลนซ์ หรืองานประจำครับ ถ้ามีไอเดียอยู่ในหัว ทักมาคุยกันได้เลย',
        'contact.reach': 'ทักผมได้เลยที่',
        'contact.email.label': 'ส่งเมลหาผม',
        'contact.email.cta': 'ส่งเมลเลย →',
        'contact.github.label': 'GitHub ของผม',
        'contact.github.cta': 'ดู repos →',
        'contact.location': 'กรุงเทพฯ · ตอบกลับภายใน 24 ชั่วโมงครับ',
    }
} as const;
